export const ORG_APP_VERSION_SETTING_KEY = 'app-version';
export const ORG_APP_VERSION_V2_2 = '2.2';

export const normalizeOrgAppVersion = (settingValue) => String(settingValue || '').trim();

export const getOrgAppVersionCacheKey = (orgId) => `${orgId}:${ORG_APP_VERSION_SETTING_KEY}`;

export const hasOrgAppVersionLoaded = (generalSettings = {}, orgId) => {
  if (!orgId) {
    return false;
  }

  return Object.prototype.hasOwnProperty.call(generalSettings, getOrgAppVersionCacheKey(orgId));
};

export const getOrgAppVersion = (generalSettings = {}, orgId) => {
  if (!orgId) {
    return '';
  }

  return normalizeOrgAppVersion(generalSettings[getOrgAppVersionCacheKey(orgId)]);
};

export const isOrgAppVersionV22 = (appVersion) =>
  normalizeOrgAppVersion(appVersion) === ORG_APP_VERSION_V2_2;
